import { render, staticRenderFns } from "./IconSvgOdt.vue?vue&type=template&id=5a958938&scoped=true&"
import script from "./IconSvgOdt.vue?vue&type=script&lang=js&"
export * from "./IconSvgOdt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a958938",
  null
  
)

export default component.exports